// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__GxIoV","mainContainer":"style_mainContainer__4ieG1"};